module.exports = __webpack_public_path__ + "static/img/shu@2x.538c02c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shu@2x.png
// module id = +kFb
// module chunks = 0